<template>
  <!-- 批量操作 -->
  <div>
    <Modal v-model="visible" title="批量操作" :mask-closable="false" width="500px" class="my-modal">
      <loading :isShow="loading" />
      <div class="confirm-box">
        <div style="margin-bottom: 20px">请确认下方数据</div>
        <!-- <div style="margin-bottom: 20px">已选择{{ detail.checkCount }}条申请中/待打款的记录</div> -->
        <!-- <div style="margin-bottom: 20px">结算主体：{{ detail.settlementEntity }}</div> -->
        <div>
          <span>合计申请业务员人数：{{ detail.userCount }}人</span>
          <span style="margin-left: 20px">金额：{{ detail.requestAmount }}元</span>
        </div>
        <!-- <div style="margin-top: 20px;margin-bottom: 10px">备注：</div>
        <Input type="textarea" v-model="detail.remark" placeholder="请输入" /> -->
      </div>
      <div slot="footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" v-if="searchParams.paymentType == '2'" @click="submit()">标记为已支付</Button>
        <Tooltip v-else-if="detail.checkCount > 10" placement="top" :content="btnText + '一次性不能超过十条！'">
          <Button :disabled="true" type="primary" style="marigin-left: 10px">{{ btnText }}</Button>
        </Tooltip>
        <Button v-else type="primary" @click="submit">{{ btnText }}</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    <!-- ok保提现验证 -->
    <okbao-check ref="okbaoCheck" @reload="reload" :type="searchParams.okbStatus == -1 ? 'rePay' : ''"></okbao-check>
    <!-- 标记已支付时选择打款日期 -->
    <select-date-modal ref="selectDateModal" v-if="$refs.okbaoCheck" @save="$refs.okbaoCheck.open" />
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import selectDateModal from './selectDateModal';
import { common } from '@/api/mixins';
import okbaoCheck from './okbaoCheck.vue';

export default {
  mixins: [common],
  components: {
    selectDateModal,
    confirmModal,
    okbaoCheck
  },
  data() {
    return {
      btnText: '发放',
      visible: false,
      params: {},
      searchParams: {},
      detail: {},
      loading: false
    };
  },
  computed: {},
  methods: {
    open(params, searchParams) {
      // this.isShowDateType = '';
      if (searchParams.okbStatus == -1 || searchParams.okbStatus == 3) {
        this.btnText = '打款';
      } else {
        this.btnText = '发放';
      }
      this.params = {
        ...params,
        operationType: searchParams.paymentType || 1
      };
      this.searchParams = searchParams;
      this.$http({
        url: '/buz/userCashWithdrawLog/okbBatchDetail',
        type: 'POST',
        data: params
      }).then(res => {
        if (res.data) {
          this.detail = res.data;
          this.visible = true;
        }
      });
    },
    submit() {
      if (this.searchParams.paymentType == 2) {
        this.$refs.selectDateModal.open(this.params);
      } else {
        this.$refs.okbaoCheck.open(this.params);
      }
    },
    // 操作完成刷新
    reload() {
      this.$emit('reload');
      this.visible = false;
      this.$refs.selectDateModal.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
  /deep/.ivu-tooltip-rel {
    .ivu-btn {
      margin-left: 10px;
    }
  }
}
</style>
